const Backbone = require('backbone');
const format = require('format');
const dustjs = require('dustjs');
const window = require('window');
require('common/_product_review_rating.dust');

const GBBView = Backbone.View.extend({
	events: {
		'change .js-finish': '_finishChanged'
	},
	initialize: function(options) {
		this.options = options;
	},
	/**
	 * @private
	 * @param {*} data
	 * @returns {void}
	 */
	_render: function(data) {
		dustjs.render(this.options.template, data, (error, markup) => {
			if (error) {
				window.clientErrorHandler(error);
			}
			this.$('.js-finish-details').html(markup);
		});
	},
	/**
	 * @private
	 * @param {Event} e
	 * @returns {void}
	 */
	_finishChanged: function(e) {
		const uniqueId = Number($(e.currentTarget).val());
		const gbb = this.options.data;
		const finish = gbb.finishes.find((finish) => {
			return finish.uniqueId === uniqueId;
		});
		const spif = gbb.spifInfo ? gbb.spifInfo.finishSpifLookup[uniqueId] : null;

		if (finish) {
			const data = {
				reviews: gbb.reviews,
				manufacturer: gbb.manufacturer,
				productId: gbb.productId,
				productLink: finish.productLink,
				price: format.currency(finish.price),
				stock: finish.stock,
				image: finish.image,
				description: gbb.description,
				device: window.BCOM.device,
				spifInfo: spif ? { minSpif: spif.manufacturerSpif + spif.buildSpif } : undefined
			};

			this._render(data);
		}
	}
});
module.exports = GBBView;
